import React from "react"
import logo from "../../../images/usbc-single.png"

const Loading = () => {
	return (
		<div style={{ backgroundImage:logo }} />
	)
}
export default Loading


// WEBPACK FOOTER //
// ./src/containers/landingPage/components/loading.js